import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';


import { OnlyBackButton, OnlySaveButton, SaveAndBackButtons } from '../../../components/base/BottomStepComponent';

import CouponGeneralBrand from '../../../assets/images/coupon/preview/SingleCoupon_brand.png';
import CouponDefaultPreview from '../../../assets/images/coupon/preview/SingleCoupon_default.png';
import CouponDetailContent from '../../../assets/images/coupon/preview/SingleCoupon_detailContent.png';
import CouponDetailTitle from '../../../assets/images/coupon/preview/SingleCoupon_detailTitle.png';
import CouponKeyVisualImage from '../../../assets/images/coupon/preview/SingleCoupon_image.png';
import CouponInstructionContent from '../../../assets/images/coupon/preview/SingleCoupon_instructionContent.png';
import CouponInstructionTitle from '../../../assets/images/coupon/preview/SingleCoupon_instructionTitle.png';
import CouponGeneralStore from '../../../assets/images/coupon/preview/SingleCoupon_store.png';
import CouponGeneralName from '../../../assets/images/coupon/preview/SingleCoupon_title.png';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { TICKET_CREATION_STEP_ONE_CONFIG } from './TicketCreationConfig';
import { useFormContext } from 'react-hook-form';
import { COUPON_SET_MEDIUM, COUPON_SET_TYPES, COUPON_TYPES } from 'config/CustomEnums';
import { ticketCreationValidate } from './CreateTicketValidate';
import { createAction } from 'utils';

const inputWithImageConfig = {
  name: CouponGeneralName,
  relatedBrand: CouponGeneralBrand,
  selectedStores: CouponGeneralStore,
  coverPhoto: CouponKeyVisualImage,
  otherPhotos: CouponKeyVisualImage,
  instructionTitle: CouponInstructionTitle,
  instructionContent: CouponInstructionContent,
  detailsTitle: CouponDetailTitle,
  detailsContent: CouponDetailContent,
};
const defaultImage = CouponDefaultPreview;

const mapPropsToState = (state) => ({
});
const CreateTicketStepOne = ({
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const campaignId = params.id;
  const isEditMode = !!campaignId;
  const { watch, setValue, getValues, setError, clearErrors }= useFormContext();
  const mediumTypeFieldName = 'mediumType';
  const shouldBeUsedInStoresFieldName = 'shouldBeUsedInStores';
  const offlineCouponSetTypeFieldName = 'offlineCouponSetType';
  const type = watch("type");
  const watchMediumType = watch(mediumTypeFieldName);
  const watchOfflineCouponSetType = watch(offlineCouponSetTypeFieldName);
  const watchShouldBeUsedInStores = watch(shouldBeUsedInStoresFieldName)

  useEffect(()=>{
    if (isEditMode) {
      return
    }

    if (type !== COUPON_TYPES.TICKET) {
      setValue("type", COUPON_TYPES.TICKET, { shouldDirty: true })
    }
    if (watchMediumType !== COUPON_SET_MEDIUM.OFFLINE) {
      setValue(mediumTypeFieldName, COUPON_SET_MEDIUM.OFFLINE, { shouldDirty: true })
    }
    if (watchOfflineCouponSetType !== COUPON_SET_TYPES.SYSTEM_GENERATED) {
      setValue(offlineCouponSetTypeFieldName, COUPON_SET_TYPES.SYSTEM_GENERATED, { shouldDirty: true })
    }
    if (!watchShouldBeUsedInStores) {
      setValue(shouldBeUsedInStoresFieldName, true, { shouldDirty: true })
    }

  }, [type, isEditMode, watchMediumType, watchOfflineCouponSetType, watchShouldBeUsedInStores])

  const saveAction = () => {
    const isValid = ticketCreationValidate({
      getValues,
      setError,
      clearErrors,
    });
    if (!isValid) {
      return;
    }

    if (isEditMode) {
      dispatch(
        createAction('createCoupon/updateCouponTemplateInput')({
          data: getValues(),
        }),
      );
    } else {
      dispatch(
        createAction('createCoupon/createCouponTemplate')({
          data: getValues(),
        }),
      );
    }

  };
  return (
    <div>
      <BaseCreationStepContentByConfig
        configuration={TICKET_CREATION_STEP_ONE_CONFIG}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
      />

      <OnlySaveButton
        saveText={"Save"}
        saveAction={saveAction}
      />
    </div>
  );
};

export default connect(mapPropsToState)(CreateTicketStepOne);